export const ApiKeys = {
    FirebaseConfig: {
        apiKey: "AIzaSyBtQEIGr4945I4yZNiw5sweBkqsnUZ4cZg",
        authDomain: "link-4b9f1.firebaseapp.com",
        projectId: "link-4b9f1",
        storageBucket: "link-4b9f1.appspot.com",
        messagingSenderId: "971878124192",
        appId: "1:971878124192:web:69282406adb50b22fa97c5",
        measurementId: "G-M56B7CKHKZ"
    }
}